import { PAGINATION_DEFAULT_LIMIT, MIN_AGE_DEFAULT } from '@config/options.js'
import { MODIO_SITE } from '@config'
import { ref } from 'vue'

const params = new URLSearchParams(location.search)

const gameIdParam = params.get('game_id')
const tagsParam = params.get('tags')
const featuredTagParam = params.get('featured')
const featuredCountParam = params.get('featured_count') || 5
const portalParam = params.get('portal')
export const platformParam = params.get('platform')
export const cookiesParam = params.get('cookies')
export const languageParam = params.get('lang')

export const GAME_ID = parseInt(gameIdParam)
export const PUBLIC_BASE_URL = import.meta.env.VITE_MODIO_API_URL.replace(
  '{{GAME_ID}}',
  GAME_ID
)
export const PRIVATE_BASE_URL = import.meta.env.VITE_MODIO_COGS_API_URL.replace(
  '{{GAME_ID}}',
  GAME_ID
)
export const LOGOUT_ENDPOINT = `${PUBLIC_BASE_URL}/oauth/logout`
export const HEADERS = {
  portal: portalParam,
  platform: platformParam,
}

export const ALLOWED_URLS = [globalThis.EMH?.url, MODIO_SITE].filter(
  (url) => url
)

export const HOST_URL = globalThis.EMH?.url || null

export const sdkPlatform = ref(false)

export const filterSettings = ref({
  tags: tagsParam,
  featured: featuredTagParam,
  featuredCount: featuredCountParam,
})

export function setFilterSetting(key, value) {
  if (value || value === null) {
    filterSettings.value[key] = value
  }
}

export const Style = ref({
  pageBackground: globalThis.EMH?.style?.page_background,
  modalBackground: globalThis.EMH?.style?.modal_background,
  buttonRadius: globalThis.EMH?.style?.button_radius,
  linkColor: globalThis.EMH?.style?.link_color,
  inputBackgroundColor: globalThis.EMH?.style?.input_background_color,

  primaryButtonColor: globalThis.EMH?.style?.primary_button_color,
  primaryButtonColorHover: globalThis.EMH?.style?.primary_button_hover_color,
  primaryButtonBorderColor: globalThis.EMH?.style?.primary_button_border_color,
  primaryButtonBorderColorHover:
    globalThis.EMH?.style?.primary_button_border_hover_color,

  secondaryButtonColor: globalThis.EMH?.style?.secondary_button_color,
  secondaryButtonColorHover:
    globalThis.EMH?.style?.secondary_button_hover_color,
  secondaryButtonBorderColor:
    globalThis.EMH?.style?.secondary_button_border_color,
  secondaryButtonBorderColorHover:
    globalThis.EMH?.style?.secondary_button_border_hover_color,

  activeButtonColor: globalThis.EMH?.style?.active_button_color,
  activeButtonColorHover: globalThis.EMH?.style?.active_button_hover_color,
  activeButtonBorderColor: globalThis.EMH?.style?.active_button_border_color,
  activeButtonBorderColorHover:
    globalThis.EMH?.style?.active_button_border_hover_color,

  tileBackgroundColor: globalThis.EMH?.style?.tile_background_color,
  tileBorderColor: globalThis.EMH?.style?.tile_border_color,
  tileBorderWidth: globalThis.EMH?.style?.tile_border_width,
  tileBorderRadius: globalThis.EMH?.style?.tile_border_radius,
})

export function setStyle(key, value) {
  if (value || value === null) {
    Style.value[key] = value
  }
}

export const Settings = ref({
  allowSubscribing: globalThis.EMH?.allow_subscribing ?? true,
  allowRating: globalThis.EMH?.allow_rating ?? true,
  allowDownloading: globalThis.EMH?.allow_downloading ?? true,
  allowCommenting: globalThis.EMH?.allow_commenting ?? true,
  showComments: globalThis.EMH?.show_comments ?? true,
  showCollection: globalThis.EMH?.show_collection ?? true,
  showGuides: globalThis.EMH?.show_guides ?? false,
  allowFiltering: globalThis.EMH?.allow_filtering ?? true,
  allowSearching: globalThis.EMH?.allow_searching ?? true,
  showUserAvatars: globalThis.EMH?.show_user_avatars ?? true,
  showSortTabs: globalThis.EMH?.show_sort_tabs ?? true,
  allowInfiniteScroll: globalThis.EMH?.allow_infinite_scroll ?? true,
  allowLinks: globalThis.EMH?.allow_links ?? true,
  ugcPerPage: globalThis.EMH?.results_per_page || PAGINATION_DEFAULT_LIMIT,
  agreementUrls: globalThis.EMH?.agreement_urls || [],
  companyName: globalThis.EMH?.company_name || '',
  minAge: globalThis.EMH?.min_age || MIN_AGE_DEFAULT,
})

export function setSettings(key, value) {
  if (typeof value === 'boolean' || typeof value === 'number') {
    Settings.value[key] = value
  }
}

export const AuthOptions = ref({
  allowEmailAuth: globalThis.EMH?.allow_email_auth ?? true,
  allowSsoAuth: globalThis.EMH?.allow_sso_auth ?? false,
  allowSteamAuth: globalThis.EMH?.allow_steam_auth ?? false,
  allowPsnAuth: globalThis.EMH?.allow_psn_auth ?? false,
  allowXboxAuth: globalThis.EMH?.allow_xbox_auth ?? false,
  allowEgsAuth: globalThis.EMH?.allow_egs_auth ?? false,
  allowDiscordAuth: globalThis.EMH?.allow_discord_auth ?? false,
  allowGoogleAuth: globalThis.EMH?.allow_google_auth ?? false,
})

export function setAuthOption(key, value) {
  if (typeof value === 'boolean' || typeof value === 'number') {
    AuthOptions.value[key] = value
  }
}
